var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdminsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "{className} ",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 94 94",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.7,63.9l4.4,4.4c1,1,2.3,1.6,3.7,1.5h5.2v4.4c0,3.3,2.7,6,6,6c0,0,0,0,0,0h4.4v5.2c0,1.4,0.5,2.7,1.5,3.7 l3.5,3.5c0.9,0.9,2.2,1.4,3.5,1.4h13.8c2.4,0,4.3-1.9,4.3-4.3l0,0V75.9c0-1.3-0.5-2.6-1.4-3.5L63.9,43.7c6-17.1-3-35.9-20.1-41.9 C31.8-2.3,18.6,0.7,9.6,9.6c-12.8,12.8-12.8,33.6,0,46.5C18.5,65,31.8,68,43.7,63.9z M13.9,13.9c10.5-10.5,27.5-10.5,38,0 c7.7,7.7,10,19.4,5.7,29.5c-0.5,1.1-0.2,2.4,0.6,3.3L88,76.4V88H76.4l-2.9-2.9V78c0-2.1-1.7-3.9-3.9-3.9l0,0l0,0h-6.5v-6.5 c0-2.1-1.7-3.9-3.9-3.9l0,0h-7.1l-5.6-5.6c-0.9-0.9-2.2-1.1-3.3-0.6C29.6,63.4,13.9,57,8.1,43.3C3.9,33.3,6.1,21.6,13.9,13.9 L13.9,13.9z M26.4,37.4c6.1,0,11-4.9,11-11s-4.9-11-11-11s-11,4.9-11,11S20.4,37.4,26.4,37.4z M26.4,21.5c2.8,0,5,2.2,5,5 s-2.2,5-5,5s-5-2.2-5-5C21.4,23.8,23.7,21.5,26.4,21.5C26.4,21.5,26.4,21.5,26.4,21.5L26.4,21.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminsIcon);
export default __webpack_public_path__ + "static/media/admins_icon.b773eb9ef693ba3905a6e19204a2365e.svg";
export { ForwardRef as ReactComponent };